/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_Guide_BodyInputs */

const en_gc_editor_guide_body = /** @type {(inputs: Gc_Editor_Guide_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with the XLSX guide, then come back to make it your own.`)
};

const zh_gc_editor_guide_body = /** @type {(inputs: Gc_Editor_Guide_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先阅读 XLSX 入门指南，再回来创建你的工作簿。`)
};

/**
* | output |
* | --- |
* | "Start with the XLSX guide, then come back to make it your own." |
*
* @param {Gc_Editor_Guide_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_guide_body = /** @type {((inputs?: Gc_Editor_Guide_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_Guide_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_guide_body(inputs)
	return zh_gc_editor_guide_body(inputs)
});
export { gc_editor_guide_body as "gc.editor.guide_body" }